/**
 * @description
 * Observe field changes made by the user through InputWrapper.
 * Unlike form.onChange this does not fire for programmatic changes (registerField, prefill, merge).
 */
type Listener = (formId: string, name: string[]) => void;

const listeners = new Set<Listener>();

export function onUserFieldChange(listener: Listener): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function notifyUserFieldChange(formId: string, name: string[]) {
  listeners.forEach((listener) => {
    try {
      listener(formId, name);
    } catch (e) {
      console.error(e);
    }
  });
}
